import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './UserDetail.css'; // You'll need to create this CSS file

const SERVER_URL = process.env.REACT_APP_TEST_API_URL;

const UserDetail = () => {
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [userAppointments, setUserAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // Fetch user details/
        const userResponse = await fetch(`${SERVER_URL}/api/auth/user/${userId}`);
        if (!userResponse.ok) {
          throw new Error('Failed to fetch user data');
        }
        const userData = await userResponse.json();
        console.log(userData)
        setUser(userData);

        // Fetch user's appointments
        const appointmentsResponse = await fetch(`${SERVER_URL}/api/appointment/user/${userId}`);
        if (!appointmentsResponse.ok) {
          throw new Error('Failed to fetch user appointments');
        }
        const appointmentsData = await appointmentsResponse.json();
        console.log(appointmentsData)
        setUserAppointments(appointmentsData);
        
        setLoading(false);
      } catch (error) {
        console.error('Error fetching user data:', error);
        setError(error.message);
        setLoading(false);
      }
    };

    fetchUserData();
  }, [userId]);

  if (loading) return <div className="loading">Loading user data...</div>;
  if (error) return <div className="error">Error: {error}</div>;
  if (!user) return <div className="not-found">User not found</div>;

  return (

    <div className="user-detail">
    <div className="back-link">
        <Link to="/appointments">← Back to Appointments</Link>
    </div>
    
    <div className="user-info-card">
        <h2>User Details</h2>
        <div className="user-info">
        <div className="info-item">
            <span className="label">Name:</span>
            <span className="value">{user.name}</span>
        </div>
        <div className="info-item">
            <span className="label">Email:</span>
            <span className="value">{user.email}</span>
        </div>
        <div className="info-item">
            <span className="label">Contact Number:</span>
            <span className="value">{user.contactNumber || 'N/A'}</span>
        </div> <div className="info-item">
            <span className="label">Medical History:</span>
            <span className="value">{user.medicalHistory || 'N/A'}</span>
        </div>
        <div className="info-item">
            <span className="label">DateOfBirth:</span>
            <span className="value">{new Date(user.dateOfBirth).toLocaleDateString('en-GB', {day: '2-digit', month: '2-digit', year: '2-digit'}) || 'N/A'}</span>

        </div>
        <div className="info-item">
            <span className="label">Address:</span>
            <span className="value">{user.address || 'N/A'}</span>
        </div>
        <div className="info-item">
            <span className="label">City:</span>
            <span className="value">{user.city || 'N/A'}</span>
        </div>
        {/* Add more user details as needed */}
        </div>
    </div>
    
    <div className="user-appointments">
        <h3>User's Appointments</h3>
        {userAppointments.length > 0 ? (
        <table className="appointments-table">
            <thead>
            <tr>
                <th>ID</th>
                <th>Service</th>
                <th>Date</th>
                <th>Time Slot</th>
                <th>Status</th>
            </tr>
            </thead>
            <tbody>
            {userAppointments.map((appointment, index) => (
                <tr key={appointment._id}>
                <td>{index + 1}</td>
                <td>{appointment.service}</td>
                <td>{new Date(appointment.date).toLocaleDateString('en-GB', {day: '2-digit', month: '2-digit', year: '2-digit'})}</td>
                <td>{appointment.timeSlot}</td>
                <td>
                    {appointment.status === "scheduled" ? (
                    <span className="status-badge status-scheduled">Scheduled</span>
                    ) : appointment.status === "cancelled" ? (
                    <span className="status-badge status-cancelled">Cancelled</span>
                    ) : appointment.status === "completed" ? (
                    <span className="status-badge status-complete">Completed</span>
                    ) : (
                    <span className="status-badge">{appointment.status}</span>
                    )}
                </td>
                </tr>
            ))}
            </tbody>
        </table>
        ) : (
        <p className="no-appointments">No appointments found for this user.</p>
        )}
    </div>
    </div>
       
  );
};

export default UserDetail;